import React, {useEffect, useState} from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { getNonEmptyLines } from '../../helpers/linesHelper';
import useLinesHelper from '../../helpers/useLinesHelper';
import { RootState } from '../../redux/store';

function DesktopQuickPickAll() {
    const { lines } = useSelector((state: RootState) => state.playStore);
    const { t } = useTranslation();
    const { setEmptyLine, setRandomLine } = useLinesHelper();
    const [clearDisabled, setClearDisabled] = useState<boolean>(true);
    const quickPickAll = () => {
        lines.forEach(function (line, i) {
            setRandomLine(i);
        });
    };

    const emptyAll = () => {
        lines.forEach(function (line, i) {
            setEmptyLine(i);
        });
    };

    useEffect(() => {
        if (getNonEmptyLines(lines).length > 0) {
            setClearDisabled(false);
        } else {
            setClearDisabled(true);
        }
    }, [lines]);

    return (
        <div className="row justify-content-end quick-pick-btns">
            <div className="">
                <button
                    type="button"
                    onClick={() => quickPickAll()}
                    className="btn btn-primary quick-pick mr-2"
                >
                    {t('playPicker.quickPickAll')}
                </button>
            </div>
            <div>
                <button
                    type="button"
                    disabled={clearDisabled}
                    className={`btn btn-secondary clear-all-button ${clearDisabled ? 'disabled' : ''}`}
                    onClick={() => emptyAll()}
                >
                    <span>
                        <i className="fas fa-trash" />
                    </span>
                </button>
            </div>
        </div>
    );
}

export default DesktopQuickPickAll;
